(function() {
     'use strict';

     /**
     *@ngdoc service
     * @memberof app
     *@name DataService
     *@param {service} $http
     *@description
     *Servicio que pertenece a la api de Master
     */
    angular
        .module('app')
  		.filter('objtoarray', function() {

  	
    return function(input) {
    	console.log(typeof input);
    	if(typeof input == 'array')
    		return input;

    	var arr = [];

    	angular.forEach(input, function (value, key) {
                arr.push({'key':key,'value':value});
        });  

    	return arr;
      
    };
  });


  })();
